import "./styles/Header.css"
import React from "react"
import { useNavigate } from "react-router-dom"
import bbb from "../assets/bbb.png"
import yelp from "../assets/yelp.png"
import google from "../assets/google.png"
import logo from "../assets/carousel/Logo.png"
import { Phone, MessageSquare } from "lucide-react"

function Header() {
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate("/contact")
  }

  return (
    <header className="header-container">
      {/* First Column: Images */}
      <div className="star-column">
        <img src={bbb} alt="BBB Logo" className="header-image" />
        <img src={google} alt="Google Logo" className="header-image" />
        <img src={yelp} alt="Yelp Logo" className="header-image" />
      </div>

      {/* Second Column: Company Logo */}
      <div className="logo-column">
        <img src={logo} alt="Company Logo" className="company-logo" />
      </div>

      {/* Third Column: Text Call or Book Online*/}
      <div className="contact-column">
        <div className="contact-text">
          <p>REQUEST AN ESTIMATE!</p>
          <p>BONDED & INSURED</p>
        </div>
        <a href="tel:1234567890" className="header-phone-link">
          <button className="header-phone-btn">
            <Phone /> (123) 456-7890
          </button>
        </a>
        <button className="header-quote-btn" onClick={handleButtonClick}>
          <MessageSquare /> BOOK ONLINE NOW!!
        </button>
      </div>
    </header>
  )
}

export default Header
